const mediaAccepted = {
  IMAGE: '.jpg,.jpeg,.png',
  VIDEO: '.mp4',
  AUDIO: '.mp3',
}

export default mediaAccepted
